'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var styledComponents = require('reflexbox/styled-components');
var styledSystem = require('styled-system');

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var Alert = function Alert() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 12.0712C2.625 6.85419 6.85419 2.625 12.0712 2.625C17.2881 2.625 21.5173 6.85419 21.5173 12.0712C21.5173 17.2881 17.2881 21.5173 12.0712 21.5173C6.85419 21.5173 2.625 17.2881 2.625 12.0712ZM12.0712 1.375C6.16384 1.375 1.375 6.16384 1.375 12.0712C1.375 17.9785 6.16384 22.7673 12.0712 22.7673C17.9785 22.7673 22.7673 17.9785 22.7673 12.0712C22.7673 6.16384 17.9785 1.375 12.0712 1.375ZM12.6629 17V9.58H11.3189V17H12.6629ZM11.3329 7.9C11.5103 8.068 11.7296 8.152 11.9909 8.152C12.2523 8.152 12.4669 8.068 12.6349 7.9C12.8123 7.72267 12.9009 7.508 12.9009 7.256C12.9009 7.01333 12.8123 6.81267 12.6349 6.654C12.4669 6.486 12.2523 6.402 11.9909 6.402C11.7296 6.402 11.5103 6.49067 11.3329 6.668C11.1649 6.836 11.0809 7.04133 11.0809 7.284C11.0809 7.52667 11.1649 7.732 11.3329 7.9Z",
    fill: "white"
  }));
};

var ArrowButtonLeft = function ArrowButtonLeft(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.29289 11.2929C3.90237 11.6834 3.90237 12.3166 4.29289 12.7071L10.6569 19.0711C11.0474 19.4616 11.6805 19.4616 12.0711 19.0711C12.4616 18.6805 12.4616 18.0474 12.0711 17.6569L6.41421 12L12.0711 6.34315C12.4616 5.95262 12.4616 5.31946 12.0711 4.92893C11.6805 4.53841 11.0474 4.53841 10.6569 4.92893L4.29289 11.2929ZM19 11L5 11V13L19 13V11Z",
    fill: color
  }));
};

var ArrowButtonRight = function ArrowButtonRight(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.7071 12.7071C20.0976 12.3166 20.0976 11.6834 19.7071 11.2929L13.3431 4.92893C12.9526 4.53841 12.3195 4.53841 11.9289 4.92893C11.5384 5.31946 11.5384 5.95262 11.9289 6.34315L17.5858 12L11.9289 17.6569C11.5384 18.0474 11.5384 18.6805 11.9289 19.0711C12.3195 19.4616 12.9526 19.4616 13.3431 19.0711L19.7071 12.7071ZM5 13H19V11H5V13Z",
    fill: color
  }));
};

var ArrowDown = function ArrowDown(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M18.3536 9.64645C18.5488 9.84171 18.5488 10.1583 18.3536 10.3536L12.8536 15.8536L12.5 16.2071L12.1464 15.8536L6.64645 10.3536C6.45118 10.1583 6.45118 9.84171 6.64645 9.64645C6.84171 9.45118 7.15829 9.45118 7.35355 9.64645L12.5 14.7929L17.6464 9.64645C17.8417 9.45118 18.1583 9.45118 18.3536 9.64645Z",
    fill: color
  }));
};

var ArrowUp = function ArrowUp(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.7071 5.29289C12.3166 4.90237 11.6834 4.90237 11.2929 5.29289L4.92893 11.6569C4.53841 12.0474 4.53841 12.6805 4.92893 13.0711C5.31946 13.4616 5.95262 13.4616 6.34315 13.0711L12 7.41421L17.6569 13.0711C18.0474 13.4616 18.6805 13.4616 19.0711 13.0711C19.4616 12.6805 19.4616 12.0474 19.0711 11.6569L12.7071 5.29289ZM13 18L13 6L11 6L11 18L13 18Z",
    fill: color
  }));
};

var ChevronDown = function ChevronDown(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "9",
    height: "5",
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23562 0.431005C8.3658 0.56118 8.3658 0.772235 8.23562 0.90241L4.56895 4.56908L4.33325 4.80478L4.09755 4.56908L0.430883 0.90241C0.300708 0.772235 0.300708 0.56118 0.430883 0.431005C0.561058 0.30083 0.772113 0.30083 0.902287 0.431005L4.33325 3.86197L7.76422 0.431005C7.89439 0.30083 8.10545 0.30083 8.23562 0.431005Z",
    fill: color
  }));
};

var ChevronUp = function ChevronUp(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "9",
    height: "5",
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.764379 4.56899C0.634204 4.43882 0.634204 4.22777 0.764379 4.09759L4.43105 0.430923L4.66675 0.195221L4.90245 0.430923L8.56912 4.09759C8.69929 4.22777 8.69929 4.43882 8.56912 4.56899C8.43894 4.69917 8.22789 4.69917 8.09771 4.56899L4.66675 1.13803L1.23578 4.56899C1.10561 4.69917 0.894554 4.69917 0.764379 4.56899Z",
    fill: color
  }));
};

var ChevronRight = function ChevronRight(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "8",
    height: "15",
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.204986 0.678283C0.442696 0.440572 0.828101 0.440572 1.06581 0.678283L7.45712 7.06959L7.88753 7.5L7.45712 7.93041L1.06581 14.3217C0.828101 14.5594 0.442696 14.5594 0.204986 14.3217C-0.0327247 14.084 -0.0327247 13.6986 0.204986 13.4609L6.16588 7.5L0.204986 1.53911C-0.0327247 1.3014 -0.0327247 0.915993 0.204986 0.678283Z",
    fill: color
  }));
};

var Check = function Check(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.5 7L10 16.5L6 13",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

var CloseWhite = function CloseWhite() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    fill: "white",
    stroke: "#212243",
    strokeWidth: "2"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "12.8286",
    y1: "7.17154",
    x2: "7.17176",
    y2: "12.8284",
    stroke: "#212243",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "12.8285",
    y1: "12.8281",
    x2: "7.17161",
    y2: "7.17127",
    stroke: "#212243",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

var ArrowReturn = function ArrowReturn(_a) {
  var _a$color = _a.color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.29289 10.2929C1.90237 10.6834 1.90237 11.3166 2.29289 11.7071L8.65685 18.0711C9.04738 18.4616 9.68054 18.4616 10.0711 18.0711C10.4616 17.6805 10.4616 17.0474 10.0711 16.6569L4.41421 11L10.0711 5.34315C10.4616 4.95262 10.4616 4.31946 10.0711 3.92893C9.68054 3.53841 9.04738 3.53841 8.65685 3.92893L2.29289 10.2929ZM17 10L3 10V12L17 12V10Z",
    fill: "#212243"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17 11C18.3333 11 21 11.8 21 15C21 19 17 19 17 19",
    stroke: "#212243",
    strokeWidth: "2"
  }));
};

var Close = function Close(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    "data-test-id": "svg-close",
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 12.0712C2.625 6.85426 6.85419 2.62506 12.0712 2.62506C17.2881 2.62506 21.5173 6.85426 21.5173 12.0712C21.5173 17.2882 17.2881 21.5174 12.0712 21.5174C6.85419 21.5174 2.625 17.2882 2.625 12.0712ZM12.0712 1.37506C6.16384 1.37506 1.375 6.1639 1.375 12.0712C1.375 17.9786 6.16384 22.7674 12.0712 22.7674C17.9785 22.7674 22.7673 17.9786 22.7673 12.0712C22.7673 6.1639 17.9785 1.37506 12.0712 1.37506ZM8.14645 8.14651C8.34171 7.95125 8.65829 7.95125 8.85355 8.14651L12.0356 11.3286L15.2177 8.14658C15.4129 7.95132 15.7295 7.95132 15.9248 8.14658C16.12 8.34185 16.12 8.65843 15.9248 8.85369L12.7428 12.0357L15.9246 15.2176C16.1199 15.4128 16.1199 15.7294 15.9246 15.9247C15.7294 16.1199 15.4128 16.1199 15.2175 15.9247L12.0356 12.7428L8.8537 15.9248C8.65844 16.12 8.34185 16.12 8.14659 15.9248C7.95133 15.7295 7.95133 15.4129 8.14659 15.2177L11.3285 12.0357L8.14645 8.85361C7.95118 8.65835 7.95118 8.34177 8.14645 8.14651Z",
    fill: color
  }));
};

var CloseIcon = function CloseIcon(_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 24 : _a$size,
      svgProps = __rest(_a, ["size"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74935 8.04753C1.74935 4.56954 4.56881 1.75008 8.0468 1.75008C11.5248 1.75008 14.3442 4.56954 14.3442 8.04753C14.3442 11.5255 11.5248 14.345 8.0468 14.345C4.56881 14.345 1.74935 11.5255 1.74935 8.04753ZM8.0468 0.916748C4.10857 0.916748 0.916016 4.10931 0.916016 8.04753C0.916016 11.9857 4.10857 15.1783 8.0468 15.1783C11.985 15.1783 15.1776 11.9857 15.1776 8.04753C15.1776 4.10931 11.985 0.916748 8.0468 0.916748ZM5.43031 5.43105C5.56049 5.30087 5.77154 5.30087 5.90172 5.43105L8.02311 7.55244L10.1445 5.4311C10.2746 5.30092 10.4857 5.30092 10.6159 5.4311C10.746 5.56127 10.746 5.77233 10.6159 5.9025L8.49452 8.02384L10.6158 10.1451C10.7459 10.2753 10.7459 10.4863 10.6158 10.6165C10.4856 10.7467 10.2745 10.7467 10.1444 10.6165L8.02311 8.49525L5.90182 10.6165C5.77164 10.7467 5.56059 10.7467 5.43041 10.6165C5.30024 10.4864 5.30024 10.2753 5.43041 10.1451L7.55171 8.02384L5.43031 5.90245C5.30014 5.77228 5.30014 5.56122 5.43031 5.43105Z",
    fill: "#212243"
  }));
};

var EditIcon = function EditIcon(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 12.0712C2.625 6.85426 6.85419 2.62506 12.0712 2.62506C17.2881 2.62506 21.5173 6.85426 21.5173 12.0712C21.5173 17.2882 17.2881 21.5174 12.0712 21.5174C6.85419 21.5174 2.625 17.2882 2.625 12.0712ZM12.0712 1.37506C6.16384 1.37506 1.375 6.1639 1.375 12.0712C1.375 17.9786 6.16384 22.7674 12.0712 22.7674C17.9785 22.7674 22.7673 17.9786 22.7673 12.0712C22.7673 6.1639 17.9785 1.37506 12.0712 1.37506ZM15.3737 6.66782C15.2822 6.5649 15.1523 6.50426 15.0147 6.50022C14.877 6.49617 14.7438 6.54907 14.6464 6.64645L7.64645 13.6464L7.53314 13.7597L7.5068 13.9178L7.0068 16.9178L6.87028 17.737L7.65811 17.4743L10.6581 16.4743L10.7748 16.4354L10.8602 16.3468L17.3602 9.59682C17.5413 9.40874 17.5472 9.11297 17.3737 8.91782L15.3737 6.66782ZM8.12972 16.263L8.46686 14.2403L12.906 9.80115L14.3124 11.3202L10.2252 15.5646L8.12972 16.263ZM15.0071 10.5987L13.6136 9.09351L14.9786 7.72852L16.3189 9.23641L15.0071 10.5987Z",
    fill: color
  }));
};

var ListIcon = function ListIcon(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("circle", {
    cx: "4.75",
    cy: "7.75",
    r: "0.75",
    fill: color
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "4.75",
    cy: "11.75",
    r: "0.75",
    fill: color
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "4.75",
    cy: "15.75",
    r: "0.75",
    fill: color
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "7.75",
    y1: "7.75",
    x2: "18.25",
    y2: "7.75",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "7.75",
    y1: "11.75",
    x2: "18.25",
    y2: "11.75",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "7.75",
    y1: "15.75",
    x2: "18.25",
    y2: "15.75",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
};

var Information = function Information(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 12.0712C2.625 6.85426 6.85419 2.62506 12.0712 2.62506C17.2881 2.62506 21.5173 6.85426 21.5173 12.0712C21.5173 17.2882 17.2881 21.5174 12.0712 21.5174C6.85419 21.5174 2.625 17.2882 2.625 12.0712ZM12.0712 1.37506C6.16384 1.37506 1.375 6.1639 1.375 12.0712C1.375 17.9786 6.16384 22.7674 12.0712 22.7674C17.9785 22.7674 22.7673 17.9786 22.7673 12.0712C22.7673 6.1639 17.9785 1.37506 12.0712 1.37506ZM12.6629 17.0001V9.58006H11.3189V17.0001H12.6629ZM11.3329 7.90006C11.5103 8.06806 11.7296 8.15206 11.9909 8.15206C12.2523 8.15206 12.4669 8.06806 12.6349 7.90006C12.8123 7.72273 12.9009 7.50806 12.9009 7.25606C12.9009 7.01339 12.8123 6.81273 12.6349 6.65406C12.4669 6.48606 12.2523 6.40206 11.9909 6.40206C11.7296 6.40206 11.5103 6.49073 11.3329 6.66806C11.1649 6.83606 11.0809 7.04139 11.0809 7.28406C11.0809 7.52673 11.1649 7.73206 11.3329 7.90006Z",
    fill: color
  }));
};

var EmailIcon = function EmailIcon(_a) {
  var _a$color = _a.color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.75 10.1618L3.75 12.583C3.75 13.9637 4.86929 15.083 6.25 15.083L13.75 15.083C15.1307 15.083 16.25 13.9637 16.25 12.583L16.25 10.1618",
    stroke: "#212243",
    strokeWidth: "1.04167",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.25 10.4212V8C16.25 6.61929 15.1307 5.5 13.75 5.5L6.25 5.5C4.86929 5.5 3.75 6.61929 3.75 8L3.75 10.4212",
    stroke: "#212243",
    strokeWidth: "1.04167",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.58398 6.33301L10.0007 10.4997L15.0007 6.33301",
    stroke: "#212243",
    strokeWidth: "0.833333"
  }));
};

var LockIcon = function LockIcon(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("title", null, title ? title : 'Lock'), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 12.0712C2.625 6.85423 6.85419 2.62504 12.0712 2.62504C17.2881 2.62504 21.5173 6.85423 21.5173 12.0712C21.5173 17.2882 17.2881 21.5174 12.0712 21.5174C6.85419 21.5174 2.625 17.2882 2.625 12.0712ZM12.0712 1.37504C6.16384 1.37504 1.375 6.16388 1.375 12.0712C1.375 17.9785 6.16384 22.7674 12.0712 22.7674C17.9785 22.7674 22.7673 17.9785 22.7673 12.0712C22.7673 6.16388 17.9785 1.37504 12.0712 1.37504ZM15.0501 10.3443H15.1082C15.6198 10.3443 16.0384 10.7608 16.0384 11.2698V16.3339C16.0384 16.843 15.6198 17.2595 15.1082 17.2595H9.03373C8.5221 17.2595 8.10352 16.843 8.10352 16.3339V11.2698C8.10352 10.7608 8.5221 10.3443 9.03373 10.3443H9.09174V8.84011C9.09174 7.42443 10.2492 6.27275 11.6718 6.27275H12.4701C13.8928 6.27275 15.0501 7.42443 15.0501 8.84011V10.3443ZM11.6722 7.37561C10.8608 7.37561 10.2007 8.03245 10.2007 8.8399V10.344H13.9419V8.8399C13.9419 8.03245 13.2818 7.37561 12.4704 7.37561H11.6722ZM12.4041 14.3205V14.7843C12.4041 14.9663 12.2544 15.1152 12.0715 15.1152C11.8886 15.1152 11.739 14.9663 11.739 14.7843V14.3205C11.448 14.1931 11.2446 13.9041 11.2446 13.5675C11.2446 13.1131 11.6148 12.7447 12.0715 12.7447C12.5282 12.7447 12.8983 13.1131 12.8983 13.5675C12.8983 13.9041 12.695 14.1931 12.4041 14.3205Z",
    fill: color
  }));
};

var LockDocuments = function LockDocuments(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("title", null, title ? title : 'Lock'), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V9H15ZM8 7V9C6.89543 9 6 9.89543 6 11V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V11C18 9.89543 17.1046 9 16 9V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7ZM15 10H16C16.5523 10 17 10.4477 17 11V18C17 18.5523 16.5523 19 16 19H8C7.44772 19 7 18.5523 7 18V11C7 10.4477 7.44772 10 8 10H9H15ZM11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14ZM14 14C14 14.9319 13.3626 15.715 12.5 15.937V17H11.5V15.937C10.6374 15.715 10 14.9319 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14Z",
    fill: color
  }));
};

var Lock = function Lock(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("title", null, title ? title : 'Lock'), /*#__PURE__*/React__default.createElement("path", {
    id: "Path_86",
    fillRule: "evenodd",
    clipRule: "evenodd",
    "data-name": "Path 86",
    fill: color,
    d: "M412.405,500.363v-3.638a5.661,5.661,0,0,0-1.883-4.393,5.072,5.072,0,0,0-.971-.633,5.969,5.969,0,0,0-6.313.846,7.008,7.008,0,0,0-2.1,5.515v2.3a3.471,3.471,0,0,0-3.246,3.458v4.687a4.128,4.128,0,0,0,4.123,4.123h9.508a4.128,4.128,0,0,0,4.123-4.123v-4.687A3.471,3.471,0,0,0,412.405,500.363Zm-8.285-6.821a4.639,4.639,0,0,1,4.834-.653,3.757,3.757,0,0,1,.717.467,4.243,4.243,0,0,1,1.4,3.393v3.6h-8.6V498.06A5.755,5.755,0,0,1,404.12,493.542Zm10.2,14.965a2.8,2.8,0,0,1-2.792,2.792H402.02a2.912,2.912,0,0,1-2.792-2.856v-4.624a2.141,2.141,0,0,1,2.138-2.138h9.97c.483.018.6,0,.846,0a2.141,2.141,0,0,1,2.138,2.138Z",
    transform: "translate(-397.897 -491.153)"
  }));
};

var PlusIcon = function PlusIcon(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "9",
    fill: "none",
    transform: "rotate(-45 15 15)",
    stroke: color,
    strokeWidth: "2"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "15",
    y1: "11",
    x2: "15",
    y2: "19",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "19",
    y1: "15",
    x2: "11",
    y2: "15",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

var Switch = function Switch(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M17 6.4V6.4C17 5.07452 15.9255 4 14.6 4H6C4.34315 4 3 5.34315 3 7V13.1176C3 14.7095 4.29047 16 5.88235 16V16",
    stroke: color,
    strokeWidth: "1.25"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "7.625",
    y: "8.625",
    width: "13.75",
    height: "11.75",
    rx: "2.375",
    stroke: color,
    strokeWidth: "1.25"
  }));
};

var OpenLink = function OpenLink(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M5 13.5L5 8C5 6.34315 6.34315 5 8 5H17C18.6569 5 20 6.34315 20 8V16C20 17.6569 18.6569 19 17 19H11.5",
    stroke: color,
    strokeWidth: "1.25",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.64645 18.6464C4.45118 18.8417 4.45118 19.1583 4.64645 19.3536C4.84171 19.5488 5.15829 19.5488 5.35355 19.3536L4.64645 18.6464ZM13.5 11C13.5 10.7239 13.2761 10.5 13 10.5L8.5 10.5C8.22386 10.5 8 10.7239 8 11C8 11.2761 8.22386 11.5 8.5 11.5L12.5 11.5L12.5 15.5C12.5 15.7761 12.7239 16 13 16C13.2761 16 13.5 15.7761 13.5 15.5L13.5 11ZM5.35355 19.3536L13.3536 11.3536L12.6464 10.6464L4.64645 18.6464L5.35355 19.3536Z",
    fill: color
  }));
};

var Checkmark = function Checkmark(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.5 7L10 16.5L6 13",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

var MobileIcon = function MobileIcon(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("rect", {
    x: "6.625",
    y: "2.625",
    width: "10.75",
    height: "18.75",
    rx: "2.375",
    stroke: color,
    strokeWidth: "1.25"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9 3V4C9 4.55228 9.44772 5 10 5H14C14.5523 5 15 4.55228 15 4V3",
    stroke: color,
    strokeWidth: "1.25"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1",
    fill: color
  }));
};

var DocIcon = function DocIcon(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    d: "M17 20.375H8C6.68832 20.375 5.625 19.3117 5.625 18V6C5.625 4.68832 6.68832 3.625 8 3.625H14.7602L19.375 7.77835V18C19.375 19.3117 18.3117 20.375 17 20.375Z",
    stroke: color,
    strokeWidth: "1.25"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "9",
    y1: "11",
    x2: "16",
    y2: "11",
    stroke: color,
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "9",
    y1: "13",
    x2: "16",
    y2: "13",
    stroke: color,
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "9",
    y1: "15",
    x2: "16",
    y2: "15",
    stroke: color,
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "9",
    y1: "17",
    x2: "13",
    y2: "17",
    stroke: color,
    strokeLinecap: "round"
  }));
};

var HamburgerIcon = function HamburgerIcon(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 100 80",
    width: computedSize,
    height: computedSize,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("rect", {
    fill: color,
    rx: "5",
    width: "100",
    height: "8"
  }), /*#__PURE__*/React__default.createElement("rect", {
    fill: color,
    rx: "5",
    y: "30",
    width: "100",
    height: "8"
  }), /*#__PURE__*/React__default.createElement("rect", {
    fill: color,
    rx: "5",
    y: "60",
    width: "100",
    height: "8"
  }));
};

var Pencil = function Pencil(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: size,
    height: size,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "ldlfa",
    d: "M715.442 175.568l1.978 1.968-2.79.808zm9.738-10.202a.238.238 0 0 1 .155-.066.2.2 0 0 1 .154.066l2.18 2.172a.38.38 0 0 1 .067.153c0 .022 0 .11-.067.154l-1.585 1.58-2.49-2.48zm-2.53 2.523l2.483 2.476-6.527 6.51-2.483-2.477zM713.662 180c.066 0 .132 0 .176-.022l4.593-1.338c.241-.066.483-.198.659-.395l9.47-9.457c.286-.285.44-.68.44-1.097 0-.416-.154-.79-.44-1.075l-2.175-2.172a1.554 1.554 0 0 0-2.175 0l-9.449 9.457a1.82 1.82 0 0 0-.396.658l-1.34 4.585a.678.678 0 0 0 .637.856z"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "ldlfc",
    d: "M708 184v-24h24v24z"
  }), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "ldlfb"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#ldlfa"
  }))), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(-708 -160)",
    fill: color
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#ldlfa"
  })), /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#ldlfb)"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#ldlfc"
  }))))));
};

var getHeight = function getHeight(size) {
  var originalWidth = 9;
  var originalHeight = 6;
  return originalHeight * size / originalWidth;
};

var EyeOpen = function EyeOpen(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 15 : _ref$size,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === void 0 ? 'currentColor' : _ref$fillColor;
  return /*#__PURE__*/React__default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: size,
    height: getHeight(size),
    viewBox: "0 0 9 6",
    enableBackground: "new 0 0 9 6",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Good-interface"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Desktop_x2F_doc_x5F_center_x5F_Conditions_x5F_docs_x5F_004_x5F_open_x5F_all_x5F_messages",
    transform: "translate(-761.000000, -459.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Conditions-documents-Copy",
    transform: "translate(410.000000, 97.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Group-6",
    transform: "translate(48.000000, 297.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Group-11",
    transform: "translate(2.000000, 58.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(203.000000, 0.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Group-5",
    transform: "translate(99.000000, 8.000000)"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: fillColor,
    d: "M3.4,4.2c-1.6,0-3.1-0.8-3.6-2.1l0-0.1l0-0.1c0.5-1.3,2-2.1,3.6-2.1C5-0.2,6.5,0.6,7,1.9l0,0.1L7,2 C6.5,3.3,5,4.2,3.4,4.2z M0.3,2C0.8,3,2,3.7,3.4,3.7C4.8,3.7,6,3,6.5,2C6,0.9,4.8,0.2,3.4,0.2C2,0.2,0.8,1,0.3,2z"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Fill-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: fillColor,
    d: "M4.7,2c0,0.7-0.6,1.3-1.3,1.3C2.7,3.2,2.1,2.7,2.1,2s0.6-1.3,1.3-1.3C4.1,0.7,4.7,1.2,4.7,2 "
  })))))))));
};

var CrossIcon = function CrossIcon(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: computedSize,
    height: computedSize,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06507 0.682738C0.821423 0.439087 0.426388 0.439087 0.182738 0.682738C-0.0609125 0.926388 -0.0609125 1.32142 0.182738 1.56507L4.15338 5.53572L0.182905 9.5062C-0.0607457 9.74985 -0.0607457 10.1449 0.182905 10.3885C0.426555 10.6322 0.82159 10.6322 1.06524 10.3885L5.03572 6.41806L9.0061 10.3884C9.24975 10.6321 9.64478 10.6321 9.88843 10.3884C10.1321 10.1448 10.1321 9.74975 9.88843 9.5061L5.91806 5.53572L9.8886 1.56517C10.1323 1.32152 10.1323 0.926489 9.8886 0.682838C9.64495 0.439188 9.24992 0.439188 9.00627 0.682838L5.03572 4.65338L1.06507 0.682738Z",
    fill: color
  }));
};

var QuestionMark = function QuestionMark(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("title", null, title ? title : 'Question mark'), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.583 6.539a4.955 4.955 0 1 1 9.91 0 4.955 4.955 0 0 1-9.91 0ZM6.538.583a5.955 5.955 0 1 0 0 11.91 5.955 5.955 0 0 0 0-11.91ZM6.09 7.006c-.078.18-.117.39-.117.63h.9c0-.246.057-.453.171-.621.12-.168.303-.363.55-.585.191-.174.344-.324.458-.45a1.63 1.63 0 0 0 .288-.468c.084-.192.126-.411.126-.657 0-.498-.192-.888-.576-1.17-.384-.288-.903-.432-1.557-.432-.516 0-.972.087-1.368.261-.39.174-.71.423-.963.747l.657.468c.372-.474.91-.711 1.611-.711.402 0 .717.09.945.27a.838.838 0 0 1 .342.702.92.92 0 0 1-.17.558c-.115.15-.292.33-.532.54a9.095 9.095 0 0 0-.468.45 1.789 1.789 0 0 0-.297.468Zm-.08 2.511a.591.591 0 0 0 .422.162.55.55 0 0 0 .405-.162.564.564 0 0 0 .171-.414.55.55 0 0 0-.162-.405.545.545 0 0 0-.414-.171.575.575 0 0 0-.423.171.55.55 0 0 0-.162.405c0 .162.054.3.162.414Z",
    fill: color
  }));
};

var Closing = function Closing(_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 24 : _a$size,
      _a$color = _a.color,
      color = _a$color === void 0 ? '#212243' : _a$color,
      rest = __rest(_a, ["size", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 11 11"
  }, rest), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.065.183a.624.624 0 1 0-.882.882l3.97 3.97-3.97 3.971a.624.624 0 1 0 .882.883l3.97-3.97 3.971 3.97a.624.624 0 1 0 .882-.883l-3.97-3.97 3.97-3.97a.624.624 0 1 0-.882-.883l-3.97 3.97-3.97-3.97Z",
    fill: color
  }));
};

var Envelope = function Envelope(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? '#212243' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.713 6H4.287l7.395 6.09a.5.5 0 0 0 .636 0L19.714 6ZM3.2 6.4A.996.996 0 0 0 3 7v10c0 .223.073.43.197.596l6.14-6.14L3.2 6.4ZM19.793 18H4.207l5.906-5.906.933.768a1.5 1.5 0 0 0 1.908 0l.933-.768L19.793 18Zm1.01-.404A.996.996 0 0 0 21 17V7a.996.996 0 0 0-.2-.6l-6.138 5.055 6.141 6.141ZM2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7Z",
    fill: color
  }));
};

var DOC = function DOC(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#1E7ED6"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#1969B3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.288 23.8h1.908c.456 0 .858.088 1.206.264.352.172.624.416.816.732.196.316.294.684.294 1.104 0 .42-.098.788-.294 1.104a1.95 1.95 0 0 1-.816.738c-.348.172-.75.258-1.206.258H5.288v-4.2Zm1.86 3.402c.42 0 .754-.116 1.002-.348.252-.236.378-.554.378-.954 0-.4-.126-.716-.378-.948-.248-.236-.582-.354-1.002-.354H6.26v2.604h.888Zm5.131.87c-.436 0-.83-.094-1.182-.282a2.127 2.127 0 0 1-.822-.774 2.154 2.154 0 0 1-.294-1.116c0-.412.098-.782.294-1.11.2-.332.474-.592.822-.78a2.469 2.469 0 0 1 1.182-.282c.436 0 .828.094 1.176.282a2.113 2.113 0 0 1 1.122 1.89c0 .412-.1.784-.3 1.116-.2.328-.474.586-.822.774-.348.188-.74.282-1.176.282Zm0-.828c.248 0 .472-.056.672-.168.2-.116.356-.276.468-.48.116-.204.174-.436.174-.696 0-.26-.058-.492-.174-.696a1.186 1.186 0 0 0-.468-.474 1.315 1.315 0 0 0-.672-.174c-.248 0-.472.058-.672.174-.2.112-.358.27-.474.474a1.422 1.422 0 0 0-.168.696c0 .26.056.492.168.696.116.204.274.364.474.48.2.112.424.168.672.168Zm5.039.828c-.428 0-.816-.092-1.164-.276a2.139 2.139 0 0 1-.816-.774 2.165 2.165 0 0 1-.294-1.122c0-.416.098-.788.294-1.116.2-.332.472-.59.816-.774a2.422 2.422 0 0 1 1.17-.282c.364 0 .692.064.984.192.296.128.544.312.744.552l-.624.576a1.342 1.342 0 0 0-1.056-.492c-.26 0-.492.058-.696.174-.204.112-.364.27-.48.474a1.422 1.422 0 0 0-.168.696c0 .26.056.492.168.696.116.204.276.364.48.48.204.112.436.168.696.168.42 0 .772-.166 1.056-.498l.624.576c-.2.244-.448.43-.744.558a2.47 2.47 0 0 1-.99.192ZM7 13h10v1H7zM7 15h10v1H7zM7 17h10v1H7zM7 19h10v1H7zM7 11h4.333v1H7z",
    fill: "#fff"
  }));
};

var DOCX = function DOCX(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#1E7ED6"
  }), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#1969B3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.187 23.8h1.908c.456 0 .858.088 1.206.264.352.172.624.416.816.732.196.316.294.684.294 1.104 0 .42-.098.788-.294 1.104a1.95 1.95 0 0 1-.816.738c-.348.172-.75.258-1.206.258H3.187v-4.2Zm1.86 3.402c.42 0 .754-.116 1.002-.348.252-.236.378-.554.378-.954 0-.4-.126-.716-.378-.948-.248-.236-.582-.354-1.002-.354H4.16v2.604h.888Zm5.131.87c-.436 0-.83-.094-1.182-.282a2.127 2.127 0 0 1-.822-.774A2.154 2.154 0 0 1 7.88 25.9c0-.412.098-.782.294-1.11.2-.332.474-.592.822-.78a2.469 2.469 0 0 1 1.182-.282c.436 0 .829.094 1.176.282a2.113 2.113 0 0 1 1.123 1.89c0 .412-.1.784-.3 1.116-.2.328-.474.586-.822.774-.348.188-.74.282-1.177.282Zm0-.828c.248 0 .472-.056.672-.168.2-.116.357-.276.469-.48.115-.204.173-.436.173-.696 0-.26-.058-.492-.174-.696a1.186 1.186 0 0 0-.467-.474 1.315 1.315 0 0 0-.673-.174c-.248 0-.472.058-.672.174-.2.112-.358.27-.474.474a1.422 1.422 0 0 0-.168.696c0 .26.056.492.168.696.116.204.274.364.474.48.2.112.424.168.672.168Zm5.039.828c-.428 0-.816-.092-1.164-.276a2.139 2.139 0 0 1-.816-.774 2.165 2.165 0 0 1-.294-1.122c0-.416.098-.788.294-1.116.2-.332.472-.59.816-.774a2.422 2.422 0 0 1 1.17-.282c.364 0 .692.064.984.192.296.128.544.312.744.552l-.624.576a1.342 1.342 0 0 0-1.056-.492c-.26 0-.492.058-.696.174-.204.112-.364.27-.48.474a1.422 1.422 0 0 0-.168.696c0 .26.056.492.168.696.116.204.276.364.48.48.204.112.436.168.696.168.42 0 .772-.166 1.056-.498l.624.576c-.2.244-.448.43-.744.558a2.47 2.47 0 0 1-.99.192ZM20.171 28l-1.014-1.458L18.161 28h-1.116l1.554-2.136-1.476-2.064h1.104l.966 1.362.948-1.362h1.05l-1.464 2.028L21.293 28h-1.122ZM7 13h10v1H7zM7 15h10v1H7zM7 17h10v1H7zM7 19h10v1H7zM7 11h4.333v1H7z",
    fill: "#fff"
  }));
};

var GIF = function GIF(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.121 25.834h.888v1.704a2.537 2.537 0 0 1-.792.396c-.3.092-.602.138-.906.138-.436 0-.828-.092-1.176-.276a2.127 2.127 0 0 1-.822-.774A2.165 2.165 0 0 1 7.02 25.9c0-.416.098-.788.294-1.116.2-.332.476-.59.828-.774a2.482 2.482 0 0 1 1.188-.282 2.6 2.6 0 0 1 1.002.186c.3.124.552.304.756.54l-.624.576a1.443 1.443 0 0 0-1.086-.474c-.268 0-.506.056-.714.168-.208.112-.37.27-.486.474a1.395 1.395 0 0 0-.174.702c0 .26.058.492.174.696.116.204.276.364.48.48.208.112.444.168.708.168.28 0 .532-.06.756-.18v-1.23Zm1.791-2.034h.972V28h-.972v-4.2Zm2.94.78v1.11h1.945v.78h-1.944V28h-.972v-4.2h3.174v.78h-2.202Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 19.5v-1.25l3.75-3.75 1.25 1.25v3.75h-5Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm3.75 5L10.5 17 8 19.5h5Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.125c0-.621.504-1.125 1.125-1.125h8.75c.621 0 1.125.504 1.125 1.125v8.75c0 .621-.504 1.125-1.125 1.125h-8.75A1.125 1.125 0 0 1 6.5 19.875v-8.75ZM7.625 11a.125.125 0 0 0-.125.125v8.75c0 .069.056.125.125.125h8.75a.125.125 0 0 0 .125-.125v-8.75a.125.125 0 0 0-.125-.125h-8.75Z",
    fill: "#9B9B9B"
  }));
};

var HEIC = function HEIC(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#A0D111"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#88B30F"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.73 23.8V28h-.972v-1.722H5.85V28h-.972v-4.2h.972v1.656h1.908V23.8h.972Zm4.246 3.42V28H9.724v-4.2h3.174v.78H10.69v.912h1.95v.756h-1.95v.972h2.286Zm.773-3.42h.972V28h-.972v-4.2Zm3.979 4.272c-.428 0-.816-.092-1.164-.276a2.139 2.139 0 0 1-.816-.774 2.165 2.165 0 0 1-.294-1.122c0-.416.098-.788.294-1.116.2-.332.472-.59.816-.774a2.422 2.422 0 0 1 1.17-.282c.364 0 .692.064.984.192.296.128.544.312.744.552l-.624.576a1.342 1.342 0 0 0-1.056-.492c-.26 0-.492.058-.696.174-.204.112-.364.27-.48.474a1.422 1.422 0 0 0-.168.696c0 .26.056.492.168.696.116.204.276.364.48.48.204.112.436.168.696.168.42 0 .772-.166 1.056-.498l.624.576c-.2.244-.448.43-.744.558a2.47 2.47 0 0 1-.99.192Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 19.5v-1.25l3.75-3.75 1.25 1.25v3.75h-5Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm3.75 5L10.5 17 8 19.5h5Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.125c0-.621.504-1.125 1.125-1.125h8.75c.621 0 1.125.504 1.125 1.125v8.75c0 .621-.504 1.125-1.125 1.125h-8.75A1.125 1.125 0 0 1 6.5 19.875v-8.75ZM7.625 11a.125.125 0 0 0-.125.125v8.75c0 .069.056.125.125.125h8.75a.125.125 0 0 0 .125-.125v-8.75a.125.125 0 0 0-.125-.125h-8.75Z",
    fill: "#fff"
  }));
};

var HEIF = function HEIF(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#A0D111"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#88B30F"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.014 23.8V28h-.972v-1.722H6.134V28h-.972v-4.2h.972v1.656h1.908V23.8h.972Zm4.246 3.42V28h-3.252v-4.2h3.174v.78h-2.208v.912h1.95v.756h-1.95v.972h2.286Zm.773-3.42h.972V28h-.972v-4.2Zm2.94.78v1.11h1.945v.78h-1.944V28h-.972v-4.2h3.174v.78h-2.202Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 19.5v-1.25l3.75-3.75 1.25 1.25v3.75h-5Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm3.75 5L10.5 17 8 19.5h5Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.125c0-.621.504-1.125 1.125-1.125h8.75c.621 0 1.125.504 1.125 1.125v8.75c0 .621-.504 1.125-1.125 1.125h-8.75A1.125 1.125 0 0 1 6.5 19.875v-8.75ZM7.625 11a.125.125 0 0 0-.125.125v8.75c0 .069.056.125.125.125h8.75a.125.125 0 0 0 .125-.125v-8.75a.125.125 0 0 0-.125-.125h-8.75Z",
    fill: "#fff"
  }));
};

var JPG = function JPG(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#43D011"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#2FB400"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.137 28.072c-.284 0-.546-.052-.786-.156a1.527 1.527 0 0 1-.582-.456l.54-.648c.228.308.488.462.78.462.396 0 .594-.232.594-.696V24.58H6.207v-.78H8.65v2.724c0 .516-.128.904-.384 1.164-.256.256-.632.384-1.128.384Zm4.29-4.272c.372 0 .694.062.966.186.276.124.488.3.636.528.148.228.222.498.222.81 0 .308-.074.578-.222.81-.148.228-.36.404-.636.528a2.38 2.38 0 0 1-.966.18h-.846V28H9.61v-4.2h1.818Zm-.054 2.25c.292 0 .514-.062.666-.186.152-.128.228-.308.228-.54 0-.236-.076-.416-.228-.54-.152-.128-.374-.192-.666-.192h-.792v1.458h.792Zm5.469-.216h.888v1.704a2.537 2.537 0 0 1-.792.396c-.3.092-.602.138-.906.138-.436 0-.828-.092-1.176-.276a2.127 2.127 0 0 1-.822-.774 2.165 2.165 0 0 1-.294-1.122c0-.416.098-.788.294-1.116.2-.332.476-.59.828-.774a2.482 2.482 0 0 1 1.188-.282 2.6 2.6 0 0 1 1.002.186c.3.124.552.304.756.54l-.624.576a1.443 1.443 0 0 0-1.086-.474c-.268 0-.506.056-.714.168-.208.112-.37.27-.486.474a1.395 1.395 0 0 0-.174.702c0 .26.058.492.174.696.116.204.276.364.48.48.208.112.444.168.708.168.28 0 .532-.06.756-.18v-1.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 19.5v-1.25l3.75-3.75 1.25 1.25v3.75h-5Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm3.75 5L10.5 17 8 19.5h5Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.125c0-.621.504-1.125 1.125-1.125h8.75c.621 0 1.125.504 1.125 1.125v8.75c0 .621-.504 1.125-1.125 1.125h-8.75A1.125 1.125 0 0 1 6.5 19.875v-8.75ZM7.625 11a.125.125 0 0 0-.125.125v8.75c0 .069.056.125.125.125h8.75a.125.125 0 0 0 .125-.125v-8.75a.125.125 0 0 0-.125-.125h-8.75Z",
    fill: "#fff"
  }));
};

var ODP = function ODP(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.325 28.072c-.436 0-.83-.094-1.182-.282a2.127 2.127 0 0 1-.822-.774 2.154 2.154 0 0 1-.294-1.116c0-.412.098-.782.294-1.11.2-.332.474-.592.822-.78a2.469 2.469 0 0 1 1.182-.282c.436 0 .828.094 1.176.282a2.113 2.113 0 0 1 1.122 1.89c0 .412-.1.784-.3 1.116-.2.328-.474.586-.822.774-.348.188-.74.282-1.176.282Zm0-.828c.248 0 .472-.056.672-.168.2-.116.356-.276.468-.48.116-.204.174-.436.174-.696 0-.26-.058-.492-.174-.696a1.186 1.186 0 0 0-.468-.474 1.315 1.315 0 0 0-.672-.174c-.248 0-.472.058-.672.174-.2.112-.358.27-.474.474a1.422 1.422 0 0 0-.168.696c0 .26.056.492.168.696.116.204.274.364.474.48.2.112.424.168.672.168Zm3.029-3.444h1.908c.455 0 .857.088 1.205.264.352.172.624.416.816.732.197.316.295.684.295 1.104 0 .42-.098.788-.294 1.104a1.95 1.95 0 0 1-.817.738c-.348.172-.75.258-1.206.258h-1.907v-4.2Zm1.86 3.402c.42 0 .753-.116 1.002-.348.252-.236.378-.554.378-.954 0-.4-.127-.716-.378-.948-.248-.236-.582-.354-1.002-.354h-.889v2.604h.889Zm4.914-3.402c.372 0 .695.062.966.186.276.124.488.3.636.528.148.228.223.498.223.81 0 .308-.075.578-.223.81-.148.228-.36.404-.636.528a2.38 2.38 0 0 1-.966.18h-.846V28h-.972v-4.2h1.818Zm-.053 2.25c.291 0 .514-.062.666-.186.151-.128.227-.308.227-.54 0-.236-.076-.416-.227-.54-.152-.128-.375-.192-.666-.192h-.793v1.458h.793ZM17.154 15.923a5.077 5.077 0 1 1-5.077-5.077v5.077h5.077Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18 15.077A5.077 5.077 0 0 0 12.923 10v5.077H18Z",
    fill: "#9B9B9B"
  }));
};

var ODS = function ODS(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.61 28.072c-.437 0-.83-.094-1.183-.282a2.127 2.127 0 0 1-.822-.774 2.154 2.154 0 0 1-.294-1.116c0-.412.098-.782.294-1.11.2-.332.474-.592.822-.78a2.469 2.469 0 0 1 1.182-.282c.436 0 .828.094 1.176.282a2.113 2.113 0 0 1 1.122 1.89c0 .412-.1.784-.3 1.116-.2.328-.474.586-.822.774-.348.188-.74.282-1.176.282Zm0-.828c.247 0 .471-.056.671-.168.2-.116.356-.276.468-.48.116-.204.174-.436.174-.696 0-.26-.058-.492-.174-.696a1.186 1.186 0 0 0-.468-.474 1.315 1.315 0 0 0-.672-.174c-.248 0-.472.058-.672.174-.2.112-.358.27-.474.474a1.422 1.422 0 0 0-.168.696c0 .26.056.492.168.696.116.204.274.364.474.48.2.112.424.168.672.168Zm3.028-3.444h1.908c.456 0 .858.088 1.206.264.352.172.624.416.816.732.196.316.294.684.294 1.104 0 .42-.098.788-.294 1.104a1.95 1.95 0 0 1-.816.738c-.348.172-.75.258-1.206.258h-1.908v-4.2Zm1.86 3.402c.42 0 .754-.116 1.002-.348.252-.236.378-.554.378-.954 0-.4-.126-.716-.378-.948-.248-.236-.582-.354-1.002-.354h-.888v2.604h.888Zm4.477.87c-.332 0-.654-.044-.966-.132a2.302 2.302 0 0 1-.744-.354l.33-.732c.18.132.394.238.642.318.248.08.496.12.744.12.276 0 .48-.04.612-.12.132-.084.198-.194.198-.33 0-.1-.04-.182-.12-.246a.822.822 0 0 0-.3-.162 5.646 5.646 0 0 0-.492-.132 6.843 6.843 0 0 1-.786-.228 1.3 1.3 0 0 1-.528-.366c-.144-.168-.216-.392-.216-.672 0-.244.066-.464.198-.66.132-.2.33-.358.594-.474.268-.116.594-.174.978-.174.268 0 .53.032.786.096s.48.156.672.276l-.3.738a2.342 2.342 0 0 0-1.164-.33c-.272 0-.474.044-.606.132a.404.404 0 0 0-.192.348c0 .144.074.252.222.324.152.068.382.136.69.204.32.076.582.152.786.228.204.076.378.196.522.36.148.164.222.386.222.666 0 .24-.068.46-.204.66-.132.196-.332.352-.6.468-.268.116-.594.174-.978.174ZM7 11h1.667v1H7zM7 13h1.667v1H7zM7 15h1.667v1H7zM7 17h1.667v1H7zM7 19h1.667v1H7zM9.5 11h3.333v1H9.5zM9.5 13h3.333v1H9.5zM9.5 15h3.333v1H9.5zM9.5 17h3.333v1H9.5zM9.5 19h3.333v1H9.5zM13.666 11h3.333v1h-3.333zM13.666 13h3.333v1h-3.333zM13.666 15h3.333v1h-3.333zM13.666 17h3.333v1h-3.333zM13.666 19h3.333v1h-3.333z",
    fill: "#9B9B9B"
  }));
};

var ODT = function ODT(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.697 28.072c-.436 0-.83-.094-1.182-.282a2.127 2.127 0 0 1-.822-.774 2.154 2.154 0 0 1-.294-1.116c0-.412.098-.782.294-1.11.2-.332.474-.592.822-.78a2.469 2.469 0 0 1 1.182-.282c.436 0 .828.094 1.176.282a2.113 2.113 0 0 1 1.122 1.89c0 .412-.1.784-.3 1.116-.2.328-.474.586-.822.774-.348.188-.74.282-1.176.282Zm0-.828c.248 0 .472-.056.672-.168.2-.116.356-.276.468-.48.116-.204.174-.436.174-.696 0-.26-.058-.492-.174-.696a1.186 1.186 0 0 0-.468-.474 1.315 1.315 0 0 0-.672-.174c-.248 0-.472.058-.672.174-.2.112-.358.27-.474.474a1.422 1.422 0 0 0-.168.696c0 .26.056.492.168.696.116.204.274.364.474.48.2.112.424.168.672.168Zm3.029-3.444h1.907c.457 0 .859.088 1.207.264.351.172.623.416.816.732.195.316.293.684.293 1.104 0 .42-.098.788-.293 1.104a1.95 1.95 0 0 1-.817.738c-.348.172-.75.258-1.206.258h-1.907v-4.2Zm1.86 3.402c.42 0 .753-.116 1.002-.348.252-.236.378-.554.378-.954 0-.4-.127-.716-.378-.948-.248-.236-.582-.354-1.002-.354h-.889v2.604h.889Zm3.908-2.61H15.15V23.8h3.66v.792h-1.344V28h-.972v-3.408ZM7 13h10v1H7zM7 15h10v1H7zM7 17h10v1H7zM7 19h10v1H7zM7 11h4.333v1H7z",
    fill: "#9B9B9B"
  }));
};

var PDF = function PDF(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#B30B00"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#7A0800"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.753 23.8c.373 0 .694.062.966.186.277.124.489.3.636.528.149.228.223.498.223.81 0 .308-.074.578-.223.81-.148.228-.36.404-.636.528a2.38 2.38 0 0 1-.965.18h-.846V28h-.973v-4.2h1.819ZM7.7 26.05c.293 0 .514-.062.667-.186.152-.128.228-.308.228-.54 0-.236-.076-.416-.228-.54-.152-.128-.374-.192-.667-.192h-.792v1.458H7.7Zm2.572-2.25h1.908c.456 0 .858.088 1.206.264.352.172.624.416.816.732.196.316.294.684.294 1.104 0 .42-.098.788-.294 1.104a1.95 1.95 0 0 1-.816.738c-.348.172-.75.258-1.206.258h-1.908v-4.2Zm1.86 3.402c.42 0 .754-.116 1.002-.348.252-.236.378-.554.378-.954 0-.4-.126-.716-.378-.948-.248-.236-.582-.354-1.002-.354h-.888v2.604h.888Zm4.07-2.622v1.11h1.944v.78H16.2V28h-.973v-4.2h3.175v.78H16.2ZM17.764 15.883c-.354-.395-1.034-.578-2.008-.578-.531 0-1.092.06-1.623.152-.355-.335-.65-.73-.945-1.127-.207-.304-.413-.609-.59-.944.295-.853.472-1.767.53-2.68 0-.823-.324-1.706-1.21-1.706a.866.866 0 0 0-.738.457c-.383.67-.236 2.04.384 3.472-.207.64-.443 1.28-.708 1.98-.237.609-.502 1.188-.827 1.736-.915.366-2.834 1.28-3.011 2.284-.06.305.03.61.265.792.207.183.502.305.798.274 1.15 0 2.302-1.644 3.1-3.076.442-.152.885-.305 1.357-.426.502-.122.975-.244 1.417-.335 1.24 1.096 2.333 1.279 2.864 1.279.738 0 1.033-.335 1.122-.61.118-.334.059-.7-.177-.944Zm-.797.58c-.03.212-.266.365-.561.365-.089 0-.177 0-.266-.03a4.192 4.192 0 0 1-1.624-.854c.384-.06.797-.091 1.181-.091.266 0 .532.03.797.061.266.06.561.183.473.548ZM11.682 9.73a.43.43 0 0 1 .266-.183c.295 0 .354.335.354.64-.03.7-.147 1.37-.354 2.04-.502-1.31-.443-2.192-.266-2.497Zm1.653 5.848c-.324.06-.649.152-.974.244-.236.06-.472.152-.738.213.118-.274.236-.548.354-.792.148-.335.266-.67.384-1.005.118.182.207.335.325.487.207.305.443.579.65.853Zm-3.572 1.767c-.738 1.218-1.476 2.01-1.89 2.01a.31.31 0 0 1-.176-.061c-.089-.061-.118-.183-.089-.274.06-.457.915-1.097 2.155-1.675Z",
    fill: "#fff"
  }));
};

var PNG = function PNG(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#F8CD46"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#D1AA30"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.41 23.8c.373 0 .695.062.967.186.276.124.488.3.636.528.148.228.222.498.222.81 0 .308-.074.578-.222.81-.148.228-.36.404-.636.528a2.38 2.38 0 0 1-.966.18h-.846V28h-.972v-4.2H7.41Zm-.053 2.25c.292 0 .514-.062.666-.186.152-.128.228-.308.228-.54 0-.236-.076-.416-.228-.54-.152-.128-.374-.192-.666-.192h-.792v1.458h.792Zm6.424-2.25V28h-.798l-2.094-2.55V28h-.96v-4.2h.804l2.088 2.55V23.8h.96Zm3.831 2.034h.888v1.704a2.537 2.537 0 0 1-.792.396c-.3.092-.602.138-.906.138-.436 0-.828-.092-1.176-.276a2.127 2.127 0 0 1-.822-.774 2.165 2.165 0 0 1-.294-1.122c0-.416.098-.788.294-1.116.2-.332.476-.59.828-.774a2.482 2.482 0 0 1 1.188-.282 2.6 2.6 0 0 1 1.002.186c.3.124.552.304.756.54l-.624.576a1.443 1.443 0 0 0-1.086-.474c-.268 0-.506.056-.714.168-.208.112-.37.27-.486.474a1.395 1.395 0 0 0-.174.702c0 .26.058.492.174.696.116.204.276.364.48.48.208.112.444.168.708.168.28 0 .532-.06.756-.18v-1.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 19.5v-1.25l3.75-3.75 1.25 1.25v3.75h-5Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm3.75 5L10.5 17 8 19.5h5Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.125c0-.621.504-1.125 1.125-1.125h8.75c.621 0 1.125.504 1.125 1.125v8.75c0 .621-.504 1.125-1.125 1.125h-8.75A1.125 1.125 0 0 1 6.5 19.875v-8.75ZM7.625 11a.125.125 0 0 0-.125.125v8.75c0 .069.056.125.125.125h8.75a.125.125 0 0 0 .125-.125v-8.75a.125.125 0 0 0-.125-.125h-8.75Z",
    fill: "#fff"
  }));
};

var PPT = function PPT(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.133 23.8c.372 0 .694.062.966.186.276.124.488.3.636.528.148.228.222.498.222.81 0 .308-.074.578-.222.81-.148.228-.36.404-.636.528a2.38 2.38 0 0 1-.966.18h-.846V28h-.972v-4.2h1.818Zm-.054 2.25c.292 0 .514-.062.666-.186.152-.128.228-.308.228-.54 0-.236-.076-.416-.228-.54-.152-.128-.374-.192-.666-.192h-.792v1.458h.792Zm4.39-2.25c.372 0 .694.062.966.186.276.124.488.3.636.528.148.228.222.498.222.81 0 .308-.074.578-.222.81-.148.228-.36.404-.636.528a2.38 2.38 0 0 1-.966.18h-.846V28h-.972v-4.2h1.818Zm-.054 2.25c.292 0 .514-.062.666-.186.152-.128.228-.308.228-.54 0-.236-.076-.416-.228-.54-.152-.128-.374-.192-.666-.192h-.792v1.458h.792Zm3.325-1.458h-1.344V23.8h3.66v.792h-1.344V28h-.972v-3.408ZM19.043 28l-1.014-1.458L17.033 28h-1.116l1.554-2.136-1.476-2.064H17.1l.966 1.362.948-1.362h1.05L18.6 25.828 20.165 28h-1.122ZM17.154 15.923a5.077 5.077 0 1 1-5.077-5.077v5.077h5.077Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18 15.077A5.077 5.077 0 0 0 12.923 10v5.077H18Z",
    fill: "#9B9B9B"
  }));
};

var PPTX = function PPTX(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.133 23.8c.372 0 .694.062.966.186.276.124.488.3.636.528.148.228.222.498.222.81 0 .308-.074.578-.222.81-.148.228-.36.404-.636.528a2.38 2.38 0 0 1-.966.18h-.846V28h-.972v-4.2h1.818Zm-.054 2.25c.292 0 .514-.062.666-.186.152-.128.228-.308.228-.54 0-.236-.076-.416-.228-.54-.152-.128-.374-.192-.666-.192h-.792v1.458h.792Zm4.39-2.25c.372 0 .694.062.966.186.276.124.488.3.636.528.148.228.222.498.222.81 0 .308-.074.578-.222.81-.148.228-.36.404-.636.528a2.38 2.38 0 0 1-.966.18h-.846V28h-.972v-4.2h1.818Zm-.054 2.25c.292 0 .514-.062.666-.186.152-.128.228-.308.228-.54 0-.236-.076-.416-.228-.54-.152-.128-.374-.192-.666-.192h-.792v1.458h.792Zm3.325-1.458h-1.344V23.8h3.66v.792h-1.344V28h-.972v-3.408ZM19.043 28l-1.014-1.458L17.033 28h-1.116l1.554-2.136-1.476-2.064H17.1l.966 1.362.948-1.362h1.05L18.6 25.828 20.165 28h-1.122ZM17.154 15.923a5.077 5.077 0 1 1-5.077-5.077v5.077h5.077Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18 15.077A5.077 5.077 0 0 0 12.923 10v5.077H18Z",
    fill: "#9B9B9B"
  }));
};

var TXT = function TXT(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.699 24.592H6.355V23.8h3.66v.792H8.671V28h-.972v-3.408ZM13.002 28l-1.014-1.458L10.992 28H9.876l1.554-2.136L9.954 23.8h1.104l.966 1.362.948-1.362h1.05l-1.464 2.028L14.124 28h-1.122Zm2.326-3.408h-1.344V23.8h3.66v.792H16.3V28h-.972v-3.408ZM7 13h10v1H7zM7 15h10v1H7zM7 17h10v1H7zM7 19h10v1H7zM7 11h4.333v1H7z",
    fill: "#9B9B9B"
  }));
};

var XLS = function XLS(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m9.358 28-1.014-1.458L7.348 28H6.232l1.554-2.136L6.31 23.8h1.104l.966 1.362.948-1.362h1.05l-1.464 2.028L10.48 28H9.358Zm1.502-4.2h.972v3.408h2.106V28H10.86v-4.2Zm4.978 4.272c-.332 0-.654-.044-.966-.132a2.302 2.302 0 0 1-.744-.354l.33-.732c.18.132.394.238.642.318.248.08.496.12.744.12.276 0 .48-.04.612-.12.132-.084.198-.194.198-.33 0-.1-.04-.182-.12-.246a.822.822 0 0 0-.3-.162 5.646 5.646 0 0 0-.492-.132 6.843 6.843 0 0 1-.786-.228 1.3 1.3 0 0 1-.528-.366c-.144-.168-.216-.392-.216-.672 0-.244.066-.464.198-.66.132-.2.33-.358.594-.474.268-.116.594-.174.978-.174.268 0 .53.032.786.096s.48.156.672.276l-.3.738a2.342 2.342 0 0 0-1.164-.33c-.272 0-.474.044-.606.132a.404.404 0 0 0-.192.348c0 .144.074.252.222.324.152.068.382.136.69.204.32.076.582.152.786.228.204.076.378.196.522.36.148.164.222.386.222.666 0 .24-.068.46-.204.66-.132.196-.332.352-.6.468-.268.116-.594.174-.978.174ZM7 11h1.667v1H7zM7 13h1.667v1H7zM7 15h1.667v1H7zM7 17h1.667v1H7zM7 19h1.667v1H7zM9.5 11h3.333v1H9.5zM9.5 13h3.333v1H9.5zM9.5 15h3.333v1H9.5zM9.5 17h3.333v1H9.5zM9.5 19h3.333v1H9.5zM13.666 11h3.333v1h-3.333zM13.666 13h3.333v1h-3.333zM13.666 15h3.333v1h-3.333zM13.666 17h3.333v1h-3.333zM13.666 19h3.333v1h-3.333z",
    fill: "#9B9B9B"
  }));
};

var XLSX = function XLSX(_a) {
  var rest = __rest(_a, []);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h12l8 8v20a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9V1l8 8h-8Z",
    fill: "#CCC"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m7.251 28-1.014-1.458L5.241 28H4.125l1.554-2.136L4.203 23.8h1.104l.966 1.362.948-1.362h1.05l-1.464 2.028L8.373 28H7.251Zm1.503-4.2h.972v3.408h2.106V28H8.754v-4.2Zm4.978 4.272c-.332 0-.654-.044-.966-.132a2.302 2.302 0 0 1-.745-.354l.33-.732c.18.132.394.238.642.318.248.08.496.12.745.12.276 0 .48-.04.612-.12.132-.084.197-.194.197-.33 0-.1-.04-.182-.12-.246a.822.822 0 0 0-.3-.162 5.646 5.646 0 0 0-.492-.132 6.843 6.843 0 0 1-.785-.228 1.3 1.3 0 0 1-.528-.366c-.144-.168-.216-.392-.216-.672 0-.244.066-.464.197-.66.132-.2.33-.358.595-.474.268-.116.594-.174.978-.174.268 0 .53.032.786.096.255.064.48.156.671.276l-.3.738a2.342 2.342 0 0 0-1.163-.33c-.272 0-.474.044-.606.132a.404.404 0 0 0-.192.348c0 .144.074.252.222.324.151.068.381.136.69.204.32.076.582.152.786.228.204.076.378.196.521.36.149.164.223.386.223.666 0 .24-.069.46-.204.66-.133.196-.333.352-.6.468-.269.116-.595.174-.979.174ZM18.753 28l-1.014-1.458L16.743 28h-1.116l1.554-2.136-1.476-2.064h1.104l.966 1.362.948-1.362h1.05l-1.464 2.028L19.875 28h-1.122ZM7 11h1.667v1H7zM7 13h1.667v1H7zM7 15h1.667v1H7zM7 17h1.667v1H7zM7 19h1.667v1H7zM9.5 11h3.333v1H9.5zM9.5 13h3.333v1H9.5zM9.5 15h3.333v1H9.5zM9.5 17h3.333v1H9.5zM9.5 19h3.333v1H9.5zM13.666 11h3.333v1h-3.333zM13.666 13h3.333v1h-3.333zM13.666 15h3.333v1h-3.333zM13.666 17h3.333v1h-3.333zM13.666 19h3.333v1h-3.333z",
    fill: "#9B9B9B"
  }));
};

var Delete = function Delete(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    "data-test-id": "svg-delete",
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, svgProps), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h2.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H6ZM5 6v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6H5Zm-.5-1a.5.5 0 0 0-.5.5V12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5.5a.5.5 0 0 0-.5-.5h-7Zm2 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Zm3 0a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Z",
    fill: color
  }));
};

var Download = function Download(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12v-.5a.5.5 0 0 0-1 0v.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.5a.5.5 0 0 0-1 0v.5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.646 11.354a.5.5 0 0 0 .708 0l3.182-3.182a.5.5 0 1 0-.708-.708L8 10.293 5.172 7.464a.5.5 0 1 0-.708.708l3.182 3.182ZM8.5 2a.5.5 0 0 0-1 0h1Zm0 9V2h-1v9h1Z",
    fill: color
  }));
};

var Search = function Search(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10ZM13.8744 14.5815C12.8291 15.4664 11.4769 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 11.4769 15.4664 12.8291 14.5815 13.8744L20.3536 19.6464C20.5488 19.8417 20.5488 20.1583 20.3536 20.3536C20.1583 20.5488 19.8417 20.5488 19.6464 20.3536L13.8744 14.5815Z",
    fill: color
  }));
};

var Documents = function Documents(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.1649 5.37105L15.3076 5.5H15.5H15.6243C15.7454 5.5 15.8624 5.54396 15.9535 5.62371L16.2828 5.24742L15.9535 5.62371L19.3293 8.57748C19.4378 8.67242 19.5 8.80959 19.5 8.95377V20C19.5 20.2761 19.2761 20.5 19 20.5V21C19 20.5 19 20.5 18.9999 20.5H18.9995H18.999H18.9982H18.9972H18.9959H18.9944H18.9927H18.9908H18.9887H18.9863H18.9838H18.981H18.978H18.9747H18.9713H18.9676H18.9637H18.9597H18.9554H18.9508H18.9461H18.9412H18.936H18.9307H18.9251H18.9194H18.9134H18.9072H18.9008H18.8942H18.8875H18.8805H18.8733H18.8659H18.8583H18.8505H18.8425H18.8343H18.826H18.8174H18.8086H18.7997H18.7905H18.7812H18.7716H18.7619H18.752H18.7419H18.7316H18.7211H18.7105H18.6996H18.6886H18.6774H18.666H18.6544H18.6426H18.6307H18.6186H18.6063H18.5938H18.5812H18.5684H18.5554H18.5422H18.5289H18.5153H18.5017H18.4878H18.4738H18.4596H18.4452H18.4307H18.416H18.4011H18.3861H18.3709H18.3556H18.3401H18.3244H18.3086H18.2926H18.2764H18.2601H18.2436H18.227H18.2102H18.1933H18.1762H18.159H18.1416H18.1241H18.1064H18.0885H18.0706H18.0524H18.0341H18.0157H17.9972H17.9784H17.9596H17.9406H17.9214H17.9022H17.8827H17.8632H17.8435H17.8237H17.8037H17.7836H17.7633H17.743H17.7225H17.7018H17.681H17.6601H17.6391H17.618H17.5967H17.5753H17.5537H17.532H17.5103H17.4883H17.4663H17.4442H17.4219H17.3995H17.377H17.3543H17.3316H17.3087H17.2857H17.2626H17.2394H17.2161H17.1926H17.1691H17.1454H17.1216H17.0977H17.0738H17.0497H17.0254H17.0011H16.9767H16.9522H16.9276H16.9028H16.878H16.8531H16.8281H16.8029H16.7777H16.7524H16.727H16.7015H16.6758H16.6501H16.6244H16.5985H16.5725H16.5464H16.5203H16.494H16.4677H16.4412H16.4147H16.3881H16.3615H16.3347H16.3079H16.2809H16.2539H16.2268H16.1997H16.1724H16.1451H16.1177H16.0902H16.0627H16.035H16.0073H15.9796H15.9517H15.9238H15.8958H15.8678H15.8397H15.8115H15.7832H15.7549H15.7265H15.698H15.6695H15.6409H15.6123H15.5836H15.5549H15.526H15.4972H15.4682H15.4392H15.4102H15.3811H15.3519H15.3227H15.2935H15.2642H15.2348H15.2054H15.1759H15.1464H15.1169H15.0873H15.0576H15.0279H14.9982H14.9684H14.9386H14.9087H14.8788H14.8489H14.8189H14.7889H14.7588H14.7287H14.6986H14.6684H14.6383H14.608H14.5778H14.5475H14.5172H14.4868H14.4564H14.426H14.3956H14.3651H14.3347H14.3042H14.2736H14.2431H14.2125H14.1819H14.1513H14.1207H14.09H14.0593H14.0286H13.9979H13.9672H13.9365H13.9058H13.875H13.8442H13.8135H13.7827H13.7519H13.7211H13.6903H13.6594H13.6286H13.5978H13.567H13.5361H13.5053H13.4744H13.4436H13.4128H13.3819H13.3511H13.3203H13.2894H13.2586H13.2278H13.197H13.1662H13.1354H13.1046H13.0738H13.043H13.0123H12.9816H12.9508H12.9201H12.8894H12.8587H12.8281H12.7974H12.7668H12.7362H12.7056H12.675H12.6444H12.6139H12.5834H12.5529H12.5225H12.492H12.4616H12.4313H12.4009H12.3706H12.3403H12.31H12.2798H12.2496H12.2195H12.1893H12.1593H12.1292H12.0992H12.0692H12.0393H12.0094H11.9795H11.9497H11.9199H11.8902H11.8605H11.8309H11.8013H11.7717H11.7422H11.7127H11.6833H11.654H11.6247H11.5954H11.5662H11.537H11.508H11.4789H11.4499H11.421H11.3921H11.3633H11.3345H11.3058H11.2772H11.2486H11.2201H11.1917H11.1633H11.135H11.1067H11.0785H11.0504H11.0224H10.9944H10.9665H10.9386H10.9109H10.8832H10.8555H10.828H10.8005H10.7731H10.7458H10.7186H10.6914H10.6643H10.6373H10.6104H10.5836H10.5568H10.5301H10.5035H10.477H10.4506H10.4243H10.398H10.3719H10.3458H10.3198H10.294H10.2682H10.2425H10.2169H10.1914H10.1659H10.1406H10.1154H10.0903H10.0653H10.0403H10.0155H9.9908H9.96618H9.94166H9.91725H9.89294H9.86874H9.84465H9.82066H9.79679H9.77302H9.74936H9.72581H9.70237H9.67905H9.65584H9.63275H9.60976H9.5869H9.56415H9.54152H9.51901H9.49662H9.47434H9.45219H9.43016H9.40826H9.38647H9.36482H9.34328H9.32188H9.3006H9.27944H9.25842H9.23753H9.21676H9.19613H9.17563H9.15526H9.13503H9.11493H9.09497H9.07514H9.05545H9.0359H9.01649H8.99721H8.97808H8.95909H8.94024H8.92154H8.90297H8.88456H8.86629H8.84816H8.83018H8.81235H8.79467H8.77714H8.75977H8.74254H8.72546H8.70854H8.69177H8.67516H8.6587H8.64241H8.62626H8.61028H8.59445H8.57879H8.56329H8.54794H8.53277H8.51775H8.5029H8.48821H8.47369H8.45934H8.44516H8.43114H8.41729H8.40362H8.39011H8.37678H8.36362H8.35063H8.33782H8.32518H8.31272H8.30044H8.28833H8.2764H8.26466H8.25309H8.2417H8.2305H8.21948H8.20865H8.19799H8.18753H8.17725H8.16716H8.15725H8.14754H8.13801H8.12868H8.11954H8.11059H8.10183H8.09327H8.0849H8.07673H8.06875H8.06097H8.05339H8.04601H8.03883H8.03185H8.02508H8.0185H8.01213H8.00596H8C7.83749 20.5 7.74885 20.4608 7.69923 20.4277C7.64647 20.3926 7.60506 20.3421 7.57221 20.2764C7.53839 20.2087 7.51899 20.1351 7.50882 20.0741C7.50394 20.0447 7.50169 20.0214 7.50068 20.0073C7.50027 20.0015 7.50008 19.9975 7.5 19.9955V19V18.5H7H5C4.72386 18.5 4.5 18.2761 4.5 18V4C4.5 3.72386 4.72386 3.5 5 3.5H12.901C13.0248 3.5 13.1442 3.54595 13.2361 3.62895L15.1649 5.37105Z",
    stroke: color
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5V4H13.5V5H15.6198C15.8647 5 16.1011 5.08988 16.2842 5.25259L19.6644 8.25721C19.8779 8.44698 20 8.71898 20 9.00462V20C20 20.5523 19.5523 21 19 21H8C7.44772 21 7 20.5523 7 20V6C7 5.44772 7.44772 5 8 5H12.5ZM8 20L8 6H12.5H13.5H15.5V9V9.5H16H19V20H8ZM18.4323 8.5L16.5 6.7824V8.5H18.4323ZM10 11.5C10 11.2239 10.2239 11 10.5 11H16.5C16.7761 11 17 11.2239 17 11.5C17 11.7761 16.7761 12 16.5 12H10.5C10.2239 12 10 11.7761 10 11.5ZM10 13.5C10 13.2239 10.2239 13 10.5 13H16.5C16.7761 13 17 13.2239 17 13.5C17 13.7761 16.7761 14 16.5 14H10.5C10.2239 14 10 13.7761 10 13.5ZM10.5 15C10.2239 15 10 15.2239 10 15.5C10 15.7761 10.2239 16 10.5 16H16.5C16.7761 16 17 15.7761 17 15.5C17 15.2239 16.7761 15 16.5 15H10.5ZM10 17.5C10 17.2239 10.2239 17 10.5 17H15.5C15.7761 17 16 17.2239 16 17.5C16 17.7761 15.7761 18 15.5 18H10.5C10.2239 18 10 17.7761 10 17.5Z",
    fill: color
  }));
};

var Headphones = function Headphones(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4279 9.00171C18.247 5.48412 15.3663 3 11.9999 3C8.61832 3 5.72677 5.50662 4.55602 9.04946C3.66512 9.25139 3 10.048 3 11V14C3 14.8073 3.47832 15.5029 4.16702 15.8188C4.67488 19.7609 6.39627 20.0067 10.0853 19.9999C10.2912 20.5825 10.8468 21 11.5 21C12.3284 21 13 20.3284 13 19.5C13 18.6716 12.3284 18 11.5 18C10.847 18 10.2914 18.4173 10.0854 18.9998C9.41118 19.0013 8.82102 18.9944 8.28822 18.9572C7.30952 18.889 6.71666 18.7253 6.31602 18.4501C5.94929 18.1983 5.61537 17.7625 5.37343 16.8403C5.30718 16.5879 5.24967 16.3057 5.20096 15.99C6.21116 15.8892 7 15.0367 7 14V11C7 10.1027 6.40905 9.34336 5.5951 9.09003C6.70712 6.02932 9.23881 4 11.9999 4C14.8468 4 17.4498 6.15734 18.5042 9.37819C18.1949 9.65296 18 10.0537 18 10.5V14.5C18 15.3284 18.6716 16 19.5 16C20.3284 16 21 15.3284 21 14.5V10.5C21 9.67157 20.3284 9 19.5 9C19.4758 9 19.4518 9.00058 19.4279 9.00171ZM5 15C5.55228 15 6 14.5523 6 14V11C6 10.4477 5.55228 10 5 10C4.44772 10 4 10.4477 4 11V14C4 14.5523 4.44772 15 5 15ZM20 10.5V14.5C20 14.7761 19.7761 15 19.5 15C19.2239 15 19 14.7761 19 14.5V10.5C19 10.2239 19.2239 10 19.5 10C19.7761 10 20 10.2239 20 10.5Z",
    fill: color
  }));
};

var DollarHouse = function DollarHouse(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.9999V8.29302L12 4.16113L5 8.29302V18.9999L19 18.9999ZM4.49168 7.43186C4.18698 7.61171 4 7.9392 4 8.29302V18.9999C4 19.5521 4.44772 19.9999 5 19.9999H19C19.5523 19.9999 20 19.5521 20 18.9999V8.29302C20 7.9392 19.813 7.61171 19.5083 7.43186L12.5083 3.29997C12.1947 3.11486 11.8053 3.11486 11.4917 3.29997L4.49168 7.43186Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4997 8.5C11.4997 8.22386 11.7236 8 11.9997 8C12.2759 8 12.4997 8.22386 12.4997 8.5V9H12.7826C13.8568 9 14.7566 9.74622 14.9921 10.7485C15.0559 11.0199 14.8249 11.25 14.5462 11.25C14.2721 11.25 14.058 11.0216 13.95 10.7697C13.7559 10.317 13.3063 10 12.7826 10H12.4997V12.5H12.7499C13.9926 12.5 14.9999 13.5074 14.9999 14.75C14.9999 15.9926 13.9926 17 12.7499 17H12.4997V17.5C12.4997 17.7761 12.2759 18 11.9997 18C11.7236 18 11.4997 17.7761 11.4997 17.5V17H11.2173C10.1431 17 9.24322 16.2538 9.00775 15.2515C8.944 14.9801 9.17494 14.75 9.45367 14.75C9.72777 14.75 9.94184 14.9784 10.0499 15.2303C10.244 15.683 10.6936 16 11.2173 16H11.4997V13.5H11.2499C10.0073 13.5 8.99993 12.4926 8.99993 11.25C8.99993 10.0074 10.0073 9 11.2499 9H11.4997V8.5ZM12.4997 16H12.7499C13.4403 16 13.9999 15.4404 13.9999 14.75C13.9999 14.0596 13.4403 13.5 12.7499 13.5H12.4997V16ZM11.2499 10H11.4997V12.5H11.2499C10.5596 12.5 9.99993 11.9404 9.99993 11.25C9.99993 10.5596 10.5596 10 11.2499 10Z",
    fill: color
  }));
};

var Shield = function Shield(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 9.5L11.0006 14.9063C10.9233 15.0234 10.7816 15.032 10.6954 14.9249L9 12.8159",
    stroke: color,
    strokeWidth: "1.25",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.2236 3.67082L19.1836 7.15083C19.3658 7.2419 19.4685 7.42749 19.4524 7.61709C19.3455 8.8712 19.1298 10.6028 18.7815 12.2417C18.4285 13.9034 17.9551 15.3878 17.3703 16.2102C16.161 17.9108 13.6738 19.5307 12.2087 20.3267C12.0802 20.3964 11.9243 20.3973 11.7896 20.3251C10.9235 19.8605 9.74115 19.1705 8.65866 18.4187C7.55844 17.6546 6.6251 16.8696 6.1938 16.2226C5.99374 15.9226 5.792 15.4164 5.60235 14.7405C5.41579 14.0756 5.25172 13.2869 5.11032 12.4512C4.82763 10.7804 4.64086 8.95378 4.54253 7.61977C4.52837 7.42773 4.6326 7.24272 4.81367 7.15218L11.7764 3.67082C11.9172 3.60044 12.0828 3.60044 12.2236 3.67082Z",
    stroke: color
  }));
};

var GlobeOutline = function GlobeOutline(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? '#212243' : _a$color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 15 15",
    height: computedSize,
    width: computedSize
  }, svgProps), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.167 7.804v5.634c-.675-.13-1.358-.653-1.924-1.597-.61-1.016-1.02-2.433-1.071-4.037h2.995Zm.666 0v5.634c.675-.13 1.358-.653 1.924-1.597.61-1.016 1.02-2.433 1.071-4.037H7.833Zm2.995-.667H7.833V1.503c.675.13 1.358.653 1.924 1.596.61 1.017 1.02 2.434 1.071 4.038Zm.667.667c-.065 2.204-.772 4.127-1.817 5.259a6.003 6.003 0 0 0 3.813-5.26h-1.996Zm1.996-.667h-1.996c-.065-2.204-.772-4.127-1.817-5.259a6.004 6.004 0 0 1 3.813 5.26Zm.668.667h.008v-.667h-.008A6.667 6.667 0 0 0 7.833.812V.804h-.666v.008A6.667 6.667 0 0 0 .842 7.137H.833v.667h.009a6.667 6.667 0 0 0 6.325 6.325v.008h.666v-.008a6.667 6.667 0 0 0 6.325-6.325Zm-12.65 0a6.003 6.003 0 0 0 3.813 5.259c-1.045-1.133-1.752-3.055-1.817-5.26H1.509Zm0-.667h1.996c.065-2.204.772-4.127 1.817-5.259a6.004 6.004 0 0 0-3.813 5.26Zm2.663 0c.05-1.604.461-3.021 1.071-4.038.566-.943 1.25-1.467 1.924-1.596v5.634H4.172Z",
    fill: color
  }));
};

var DocID = function DocID(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === void 0 ? '#3B3B3B' : _ref$fillColor;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    version: "1.1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 9.5C12.9998 9.22386 13.2236 9 13.4998 9H18.4998C18.7759 9 18.9998 9.22386 18.9998 9.5C18.9998 9.77614 18.7759 10 18.4998 10H13.4998C13.2236 10 12.9998 9.77614 12.9998 9.5ZM12.9998 13.5C12.9998 13.2239 13.2236 13 13.4998 13H16.4998C16.7759 13 16.9998 13.2239 16.9998 13.5C16.9998 13.7761 16.7759 14 16.4998 14H13.4998C13.2236 14 12.9998 13.7761 12.9998 13.5ZM13.4998 11C13.2236 11 12.9998 11.2239 12.9998 11.5C12.9998 11.7761 13.2236 12 13.4998 12H18.4998C18.7759 12 18.9998 11.7761 18.9998 11.5C18.9998 11.2239 18.7759 11 18.4998 11H13.4998ZM9.00008 10C9.00008 10.5523 8.55236 11 8.00008 11C7.4478 11 7.00008 10.5523 7.00008 10C7.00008 9.44772 7.4478 9 8.00008 9C8.55236 9 9.00008 9.44772 9.00008 10ZM10.0001 10C10.0001 11.1046 9.10465 12 8.00008 12C6.89551 12 6.00008 11.1046 6.00008 10C6.00008 8.89543 6.89551 8 8.00008 8C9.10465 8 10.0001 8.89543 10.0001 10ZM8.00008 12H6.99984C5.51261 12 4.27814 13.0822 4.04096 14.5021C3.99547 14.7745 4.22369 15 4.49984 15C4.77598 15 4.99342 14.7727 5.06155 14.5051C5.28181 13.6399 6.0661 13 6.99984 13H8.99984C9.93358 13 10.7179 13.6399 10.9381 14.5051C11.0062 14.7727 11.2237 15 11.4998 15C11.776 15 12.0042 14.7745 11.9587 14.5021C11.7215 13.0822 10.4871 12 8.99984 12H8.00008Z",
    fill: fillColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "2.5",
    y: "5.5",
    width: 24,
    height: 14,
    rx: "1.5",
    stroke: "#212243"
  }));
};

var DocDefault = function DocDefault(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === void 0 ? '#212243' : _ref$fillColor;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    version: "1.1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 20H6V4H13.5V8V8.5H14H18V20ZM19 7.5V8.5V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H13.5H14.5H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L18.7071 6.70711C18.8946 6.89464 19 7.149 19 7.41421V7.5ZM14.5 4H14.5858L18 7.41421V7.5H14.5V4ZM8 11.5C8 11.2239 8.22386 11 8.5 11H15.5C15.7761 11 16 11.2239 16 11.5C16 11.7761 15.7761 12 15.5 12H8.5C8.22386 12 8 11.7761 8 11.5ZM8.5 13C8.22386 13 8 13.2239 8 13.5C8 13.7761 8.22386 14 8.5 14H15.5C15.7761 14 16 13.7761 16 13.5C16 13.2239 15.7761 13 15.5 13H8.5ZM8 15.5C8 15.2239 8.22386 15 8.5 15H15.5C15.7761 15 16 15.2239 16 15.5C16 15.7761 15.7761 16 15.5 16H8.5C8.22386 16 8 15.7761 8 15.5ZM8.5 17C8.22386 17 8 17.2239 8 17.5C8 17.7761 8.22386 18 8.5 18H13.5C13.7761 18 14 17.7761 14 17.5C14 17.2239 13.7761 17 13.5 17H8.5Z",
    fill: fillColor
  }));
};

var Upload = function Upload(_a) {
  var _a$color = _a.color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em'; // 1em use the font size

  var title = rest.title,
      svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: computedSize,
    width: computedSize
  }, svgProps, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.238 14.853.033.01c.286.088.595.137.92.137C19.823 15 21 13.803 21 12.5c0-1.066-.772-2.046-1.957-2.383a1 1 0 0 1-.727-.955c-.005-.714-.545-1.207-1.11-1.207h-.026a1 1 0 0 1-.9-.517C15.469 5.962 13.97 5 12.281 5c-2.013 0-3.765 1.374-4.389 3.348a1 1 0 0 1-1.094.688A3.622 3.622 0 0 0 6.286 9C4.405 9 3 10.407 3 12s1.405 3 3.286 3c.35 0 .687-.05 1-.142a1 1 0 0 1 .281-.04h.147v1h-.147A4.568 4.568 0 0 1 6.286 16C3.919 16 2 14.21 2 12s1.919-4 4.286-4c.222 0 .44.016.653.046C7.682 5.696 9.793 4 12.28 4c2.084 0 3.902 1.189 4.875 2.955h.05c1.16 0 2.102.983 2.11 2.2C20.871 9.596 22 10.927 22 12.5c0 1.933-1.706 3.5-3.81 3.5-.328 0-.648-.038-.952-.11v-1.037Z",
    fill: "#212243"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.646 10.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L12.5 12.207V18.5a.5.5 0 0 1-1 0v-6.293l-1.146 1.147a.5.5 0 0 1-.708-.708l2-2Z",
    fill: "#212243"
  }));
};

var CheckmarkGreen = function CheckmarkGreen(_a) {
  var _a$color = _a.color,
      rest = __rest(_a, ["color"]);

  var computedSize = rest.size || '1em';

  var svgProps = __rest(rest, ["title"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({}, svgProps, {
    height: computedSize,
    width: computedSize,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z",
    fill: "#43D011"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m11.75 4.625-5 6.275a.249.249 0 0 1-.38.02L4.25 8.68",
    stroke: "#fff",
    "stroke-linecap": "round"
  }));
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    backface-visibility: hidden;\n    &:not(:root) {\n        overflow: hidden;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var documentIcons = {
  DOC: DOC,
  DOCX: DOCX,
  GIF: GIF,
  HEIC: HEIC,
  HEIF: HEIF,
  JPG: JPG,
  ODP: ODP,
  ODS: ODS,
  ODT: ODT,
  PDF: PDF,
  PNG: PNG,
  PPT: PPT,
  Pptx: PPTX,
  TXT: TXT,
  XLS: XLS,
  XLSX: XLSX
}; // Icons map from props.name to SVG

var icons = Object.assign({
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-right': ChevronRight,
  'email-icon': EmailIcon,
  'arrow-button-left': ArrowButtonLeft,
  'arrow-button-right': ArrowButtonRight,
  'arrow-down': ArrowDown,
  'arrow-up': ArrowUp,
  'arrow-return': ArrowReturn,
  'edit-icon': EditIcon,
  'lock-icon': LockIcon,
  'lock-icon-plain': Lock,
  'lock-documents': LockDocuments,
  'open-link': OpenLink,
  'plus-icon': PlusIcon,
  'mobile-icon': MobileIcon,
  'list-icon': ListIcon,
  'doc-icon': DocIcon,
  'eye-open': EyeOpen,
  'question-mark': QuestionMark,
  'globe-outline': GlobeOutline,
  pencil: Pencil,
  checkmark: Checkmark,
  close: Close,
  check: Check,
  information: Information,
  "switch": Switch,
  hamburger: HamburgerIcon,
  cross: CrossIcon,
  closing: Closing,
  envelope: Envelope,
  "delete": Delete,
  download: Download,
  search: Search,
  documents: Documents,
  headphones: Headphones,
  'dollar-house': DollarHouse,
  shield: Shield,
  'doc-id': DocID,
  'doc-default': DocDefault,
  upload: Upload,
  'checkmark-green': CheckmarkGreen
}, documentIcons);

var getIcon = function getIcon(name) {
  return icons[name];
};

var Svg = styled__default(styledComponents.Box)(_templateObject());
var Icon = React.forwardRef(function (_a, ref) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? '1em' : _a$size,
      name = _a.name,
      _a$color = _a.color,
      color = _a$color === void 0 ? 'currentColor' : _a$color,
      _a$role = _a.role,
      role = _a$role === void 0 ? 'presentation' : _a$role,
      _a$focusable = _a.focusable,
      focusable = _a$focusable === void 0 ? false : _a$focusable,
      rest = __rest(_a, ["size", "name", "color", "role", "focusable"]);

  var SVGIcon = getIcon(name || 'arrow-button-right');
  return /*#__PURE__*/React__default.createElement(Svg, _extends({
    ref: ref,
    as: SVGIcon,
    size: size,
    color: color,
    display: "inline-block",
    focusable: focusable,
    role: role
  }, rest));
});

var idPostfix = '-id';
var normalizeInputNameForE2E = function normalizeInputNameForE2E(name) {
  // @ts-ignore
  if (name === undefined && window.config.env !== 'production') {
    // tslint:disable-next-line no-console
    console.warn("name must be not equal undefined normalizeInputNameForE2E: ".concat(name));
  }

  return name && name.toString().trim().split('.').filter(function (i) {
    return !i.includes(idPostfix);
  }).join('_');
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: ", ";\n    font-family: ", ";\n\n    transition: all 250ms;\n    user-select: none;\n    position: relative;\n    white-space: nowrap;\n    vertical-align: middle;\n    line-height: 1.2;\n    outline: none;\n\n    &:disabled {\n        cursor: not-allowed;\n    }\n\n    padding: 1em 2.65em;\n    min-width: 2.5em;\n    border: 0;\n\n    ", "\n    ", "\n\n    /* Any props from styled-system could be use here */\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledButton = styled__default(styledComponents.Box)(_templateObject$1(), function (_ref) {
  var theme = _ref.theme;
  return theme.radii.full;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, styledSystem.variant({
  scale: 'buttons'
}), styledSystem.variant({
  prop: 'size',
  scale: 'buttonSizes'
}), styledSystem.space, styledSystem.layout, styledSystem.typography, styledSystem.color, styledSystem.borderColor, styledSystem.flexbox, styledSystem.shadow);

var ButtonIcon = function ButtonIcon(_a) {
  var icon = _a.icon,
      props = __rest(_a, ["icon"]);

  if (typeof icon === 'string') {
    return /*#__PURE__*/React__default.createElement(Icon, _extends({
      focusable: "false",
      name: icon,
      color: "currentColor"
    }, props));
  }

  return /*#__PURE__*/React__default.createElement(styledComponents.Box, _extends({
    as: icon,
    "data-custom-icon": true,
    focusable: "false",
    color: "currentColor"
  }, props));
};

var Button = React.forwardRef(function (_a, ref) {
  var children = _a.children,
      disabled = _a.disabled,
      isLoading = _a.isLoading,
      leftIcon = _a.leftIcon,
      rightIcon = _a.rightIcon,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'primary' : _a$variant,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'medium' : _a$size,
      loadingText = _a.loadingText,
      _a$iconSpacing = _a.iconSpacing,
      iconSpacing = _a$iconSpacing === void 0 ? 2 : _a$iconSpacing,
      _a$as = _a.as,
      Comp = _a$as === void 0 ? 'button' : _a$as,
      _a$type = _a.type,
      type = _a$type === void 0 ? 'button' : _a$type,
      _a$leftIconProps = _a.leftIconProps,
      leftIconProps = _a$leftIconProps === void 0 ? {} : _a$leftIconProps,
      _a$rightIconProps = _a.rightIconProps,
      rightIconProps = _a$rightIconProps === void 0 ? {} : _a$rightIconProps,
      rest = __rest(_a, ["children", "disabled", "isLoading", "leftIcon", "rightIcon", "variant", "size", "loadingText", "iconSpacing", "as", "type", "leftIconProps", "rightIconProps"]);

  var _isDisabled = disabled || isLoading;

  var id = normalizeInputNameForE2E(rest.id || 'no-translation-id'); // const id = rest.id || 'no-translation-id';

  return /*#__PURE__*/React__default.createElement(StyledButton, _extends({
    disabled: _isDisabled,
    "aria-disabled": _isDisabled,
    ref: ref,
    id: id,
    as: Comp,
    type: type,
    variant: variant,
    size: size
  }, rest), leftIcon && !isLoading && /*#__PURE__*/React__default.createElement(ButtonIcon, _extends({
    mr: iconSpacing,
    icon: leftIcon
  }, leftIconProps)), isLoading ? loadingText || /*#__PURE__*/React__default.createElement(styledComponents.Box, {
    as: "span",
    opacity: "0"
  }, children) : children, rightIcon && !isLoading && /*#__PURE__*/React__default.createElement(ButtonIcon, _extends({
    mr: -1,
    ml: iconSpacing,
    icon: rightIcon
  }, rightIconProps)));
});

var Emoji = function Emoji(_a) {
  var label = _a.label,
      symbol = _a.symbol,
      rest = __rest(_a, ["label", "symbol"]);

  return /*#__PURE__*/React__default.createElement(styledComponents.Box, _extends({
    as: "span",
    "aria-hidden": label ? undefined : true,
    "aria-label": label ? label : undefined,
    role: "img"
  }, rest), symbol);
};

// Copie from https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/reflexbox/index.d.ts
// because if change definition we have tons of error and dont have time to fix them
// Type definitions for reflexbox 4.0
// Project: https://github.com/rebassjs/rebass/tree/master/packages/reflexbox
// Definitions by: Danyil Karuna <https://github.com/iamkd>
//                 Anton Vasin <https://github.com/antonvasin>
//                 Victor Orlov <https://github.com/vittorio>
//                 Louis Hache <https://github.com/lhache>
//                 Adam Lavin <https://github.com/lavoaster>
//                 Erin Noe-Payne <https://github.com/autoric>
//                 akameco <https://github.com/akameco>
// Definitions: https://github.com/DefinitelyTyped/DefinitelyTyped
// TypeScript Version: 2.9
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
var Box;
var Flex;

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    white-space: nowrap;\n    overflow: hidden;\n\n    animation: ", " ", "s\n        linear infinite;\n    /* max-content work well on desktop but nor on real mobile */\n    /* width: max-content; */\n    width: 1520px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: auto;\n    overflow: hidden;\n    position: relative;\n    white-space: nowrap;\n    width: 100%;\n\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        &::before,\n        &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            display: block;\n            width: 50px;\n            height: 100%;\n            z-index: 99;\n        }\n        &::before {\n            left: 0;\n            background: ", ";\n        }\n        &::after {\n            right: 0;\n            background: ", ";\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    from {\n        transform: translate3d(0, 0, 0);\n    }\n    to {\n        transform: translate3d(-50%, 0, 0);\n    }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var slide = styled.keyframes(_templateObject$2());

var gradientSideStyle = function gradientSideStyle(_ref) {
  var withGradient = _ref.withGradient,
      gradientHexColor = _ref.gradientHexColor;
  return withGradient && styled.css(_templateObject2(), "linear-gradient(to right, ".concat(gradientHexColor, " 0%, ").concat(gradientHexColor, "00 99%)"), "linear-gradient(to left, ".concat(gradientHexColor, " 0%, ").concat(gradientHexColor, "00 99%)"));
};

var SlideshowContainer = styled__default(styledComponents.Box)(_templateObject3(), gradientSideStyle);
var SlideshowContentWrapper = styled__default(styledComponents.Flex)(_templateObject4(), slide, function (_ref2) {
  var duration = _ref2.duration;
  return duration ? duration * 2 : 10;
});
var Slideshow = function Slideshow(_ref3) {
  var duration = _ref3.duration,
      withGradient = _ref3.withGradient,
      _ref3$gradientHexColo = _ref3.gradientHexColor,
      gradientHexColor = _ref3$gradientHexColo === void 0 ? '#ffffff' : _ref3$gradientHexColo,
      children = _ref3.children;
  var isF = typeof children === 'function';

  var child = function child(num) {
    return isF ? children(num) : children;
  };

  return /*#__PURE__*/React__default.createElement(SlideshowContainer, {
    withGradient: withGradient,
    gradientHexColor: gradientHexColor
  }, /*#__PURE__*/React__default.createElement(SlideshowContentWrapper, {
    duration: duration
  }, /*#__PURE__*/React__default.createElement("div", null, child(1)), /*#__PURE__*/React__default.createElement("div", null, child(2))));
};
var SlideshowItem = styled__default(styledComponents.Box)(_templateObject5());

exports.Alert = Alert;
exports.ArrowButtonLeft = ArrowButtonLeft;
exports.ArrowButtonRight = ArrowButtonRight;
exports.ArrowDown = ArrowDown;
exports.ArrowReturn = ArrowReturn;
exports.ArrowUp = ArrowUp;
exports.Box = Box;
exports.Button = Button;
exports.Check = Check;
exports.ChevronDown = ChevronDown;
exports.ChevronRight = ChevronRight;
exports.ChevronUp = ChevronUp;
exports.Close = Close;
exports.CloseIcon = CloseIcon;
exports.CloseWhite = CloseWhite;
exports.CrossIcon = CrossIcon;
exports.DocIcon = DocIcon;
exports.Documents = Documents;
exports.DollarHouse = DollarHouse;
exports.EditIcon = EditIcon;
exports.Emoji = Emoji;
exports.Flex = Flex;
exports.HamburgerIcon = HamburgerIcon;
exports.Headphones = Headphones;
exports.Icon = Icon;
exports.Information = Information;
exports.ListIcon = ListIcon;
exports.Lock = Lock;
exports.LockIcon = LockIcon;
exports.MobileIcon = MobileIcon;
exports.OpenLink = OpenLink;
exports.PlusIcon = PlusIcon;
exports.Search = Search;
exports.Shield = Shield;
exports.Slideshow = Slideshow;
exports.SlideshowItem = SlideshowItem;
exports.Switch = Switch;
